<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="study.id">{{$t('modals.edit_study.title')}}</h1>
            <h1 v-else>{{$t('modals.create_study.title')}}</h1>
        </div>

        <study-form
            :study="study"
            :wrapperClass="['modal__content']"
            @saved="onSave">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </study-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import StudyForm from '@/components/forms/dashboard/StudyForm';

    import { GET_STUDIES } from '@/store/modules/studies';

    @Component({
        components: {
            StudyForm,
        }
    })
    export default class StudyModal extends Vue {
        name = 'study-modal';

        study = {};

        beforeOpen(event) {
            if (event.params && event.params.study) {
                this.study = event.params.study;
            }
        }

        onSave(study) {
            this.$notify.success(this.$t('notify.study.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            this.$store.dispatch(GET_STUDIES, {});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/StudyModal.vue